// extracted by mini-css-extract-plugin
export default {"confirmSection":"ContactConfirmation_confirmSection__dk53w","confirmIcon":"ContactConfirmation_confirmIcon__J7d5G"};